import React from "react";
import CommonButtons from "../../../../../../shared/components/CommonButtons";
import Print from "../../../../../../print-configuration/PrintConfigration";
import PaymentMethods from "./PaymentMethods";
import { Order } from "src/shared/services/interfacev2";
import { PERMISSIONS, useCheckPermission } from "src/permissionCheck/PermossionChick";

interface Props {
  droupdown: () => React.ReactNode;
  showPaymentMethods: boolean;
  remaining: () => number;
  outstangingamount: () => number;
  payments: () => void;
  getorder: Order | undefined;
  setOpenCancelDialog: (val: boolean) => void;
  printData: any;
  filteredCustomerId: string | number;
  COMPLETE: { Blue: string; name: string };
  paylate: boolean;
  cashpay: boolean;
  setpaylate: React.Dispatch<React.SetStateAction<boolean>>;
  setcashpay: React.Dispatch<React.SetStateAction<boolean>>;
  setpaycard: React.Dispatch<React.SetStateAction<boolean>>;
  paycard: boolean;
}

const OrderPaymentMethods: React.FC<Props> = ({ droupdown, showPaymentMethods, remaining, outstangingamount, payments, getorder, setOpenCancelDialog, printData, filteredCustomerId, COMPLETE, paylate, cashpay, setpaylate, setcashpay, paycard, setpaycard
}) => {
  const isPaymentMethodSelected = paylate || cashpay || paycard;
  const isCompleteEnabled = remaining() > 0 ? isPaymentMethodSelected : true;
  const { checkPermission } = useCheckPermission()
  const cancelOrder = checkPermission(PERMISSIONS.ORDER.CANCEL)

  return (
    <div className="w-full">
      {/* Dropdown */}
      <div className="w-full pl-1 pr-1">{droupdown()}</div>

      {/* Payment Methods */}
      {showPaymentMethods && (
        <div className="w-full animate-in fade-in slide-in-from-top-4 duration-500">
          {/* Section Header */}
          <div className="flex items-center gap-2 px-1">
            <div className="h-4 w-1 bg-slate-900 rounded-full" />
            <h3 className="text-[11px] font-black uppercase tracking-[0.15em] text-slate-500">Payment methods</h3>
          </div>

          <div className="bg-white border border-slate-200 rounded-3xl p-1 shadow-sm transition-all hover:shadow-md">
            {remaining() === 0 || outstangingamount() <= 0 ? (
              /* Empty State / Success State */
              <div className="flex flex-col items-center justify-center py-3 text-center">
                {/* Animated Green Circle */}
                <div className="relative flex items-center justify-center mb-1">
                  <div className="w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center animate-scaleIn">
                    <svg className="w-6 h-6 text-emerald-600 animate-drawCheck" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round">
                      <path d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                </div>

                {/* Text */}
                <h4 className="text-base font-semibold text-emerald-700">Order Balance Fully Cleared</h4>

                <p className="text-sm sm:text-base">
                  {" "}
                  You have no remaining balance for this order. <br /> Please change the order status to <b>"Delivered"</b>.{" "}
                </p>
                {/* <span className="font-semibold text-slate-700">Delivered</span>. */}
              </div>
            ) : (
              <div>
                <PaymentMethods
                  paylate={paylate}
                  cashpay={cashpay}
                  setpaylate={setpaylate}
                  setcashpay={setcashpay}
                  paycard={paycard}
                  setpaycard={setpaycard}
                />

                <div className="w-full flex justify-center mt-1">
                  <CommonButtons className="h-10 w-full sm:w-44" label="COMPLETE" disabled={!isCompleteEnabled} onClick={payments} />
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Bottom buttons */}
      <div className="flex flex-col sm:flex-row justify-around items-center gap-3 sm:gap-0 space-y-1 pb-2 mt-4 sm:mt-2 w-full">

        {cancelOrder && getorder?.orders[0].status !== "deleted" && <CommonButtons
          className="h-10 w-full sm:w-40"
          label="CANCEL ORDER"
          variant="danger"
          disabled={getorder?.orders[0].status === "Delivered" || getorder?.orders[0].status === "Cancelled"}
          onClick={() => setOpenCancelDialog(true)}
        />}

        {getorder?.orders[0].status !== "Cancelled" && getorder?.orders[0].status !== "deleted" && (
          <div className="mt-2 sm:mt-0">
            <Print PrintData={{ ...printData, Paid: printData.Paid ?? 0, clientId: filteredCustomerId ?? "0" }} BtnName="PRINT RECEIPT" username="" />
          </div>
        )}
      </div>
    </div>
  );
};

export default OrderPaymentMethods;
